"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_button_styles_1 = require("@/components/common/icon-button/icon-button.styles");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let IconButton = class IconButton extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.variant = 'tertiary';
        this.size = 'medium';
        this.ariaLabel = '';
        this.tooltipPlacement = 'bottom-start';
        this.disabled = false;
        this.ariaHasPopup = null;
        this.ariaExpanded = null;
        this.ariaControls = null;
    }
    render() {
        return (0, icon_button_utils_1.renderIconAction)({
            icon: this.icon,
            ariaLabel: this.ariaLabel,
            tooltipPlacement: this.tooltipPlacement,
            disabled: this.disabled,
            ariaHasPopup: this.ariaHasPopup,
            ariaExpanded: this.ariaExpanded,
            ariaControls: this.ariaControls,
        });
    }
};
IconButton.styles = [shared_styles_1.resetStyles, icon_button_styles_1.iconButtonStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], IconButton.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], IconButton.prototype, "variant", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], IconButton.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], IconButton.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'tooltip-placement' })
], IconButton.prototype, "tooltipPlacement", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], IconButton.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-haspopup' })
], IconButton.prototype, "ariaHasPopup", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-expanded' })
], IconButton.prototype, "ariaExpanded", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-controls' })
], IconButton.prototype, "ariaControls", void 0);
IconButton = __decorate([
    (0, decorators_js_1.customElement)('mm-icon-button')
], IconButton);
exports.IconButton = IconButton;
//# sourceMappingURL=data:application/json;base64,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